// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"8089a159","683":"8089a159"}[chunkId] + ".chunk.css";
};